import React, { useEffect } from 'react';
import { Collapse } from 'antd';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Faqs = () => {
    useEffect(() => {
        AOS.init({ duration: 800, once: false });
    }, []);

    const { Panel } = Collapse;

    const onChange = (key: string | string[]) => {
        // console.log(key);
    };

    function gotous(): void {
        window.open('https://discord.gg/M2TaS3ZQhY')
    }

    return (
        <div className="main-page-faqs">
            <div className="container">
                <div className="wrap-faqs">
                    <div className="columns">
                        <div className="colum w-6" data-aos="fade-right">
                            <div className="guide-faqs">
                                <div className="title">
                                    Frequently Asked Questions
                                </div>
                                <div className="desc">
                                    Can’t find an answer to your question? Feel free to <span onClick={gotous} className='c-us'>contact us</span>
                                </div>
                            </div>
                        </div>
                        <div className="colum w-6" data-aos="fade-left" data-aos-delay="200">
                            <div className="tabs-faqs">
                                <div className="collaps-content">
                                    <Collapse defaultActiveKey={['1']} onChange={onChange}>
                                        <Panel header="What is TinyBlock?" key="1">
                                            <p>TinyBlock is a Web3 launchpad for early-stage projects to raise funds and grow, while giving investors early access to token sales.                                            </p>
                                        </Panel>
                                        <Panel header="How many services does TinyBlock provide?" key="2">
                                            <p>At the moment, TinyBlock offers 4 core services: Launchpad, Staking, Airdrop, and GameHub.                                            </p>
                                        </Panel>
                                        <Panel header="How does the Launchpad work?" key="3">
                                            <p>Projects raise funds through IDOs, and users can join by connecting their wallet, staking (if required), and securing allocation during the sale.</p>
                                        </Panel>
                                        <Panel header="Who can join Airdrops on TinyBlock?" key="4">
                                            <p>Anyone with a wallet can join, depending on each project’s requirements.                                            </p>
                                        </Panel>
                                        <Panel header="How to stay updated with lastest news from TinyBlock?" key="5">
                                            <p>Follow us on our <a href="https://docs.tinyblock.io/contact-us/social-and-community" target="_blank" rel="noopener noreferrer">social media channels</a> for real-time updates and announcements.                                            </p>
                                        </Panel>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Faqs;